/**
 * The available camera modes
 */
export var CameraMode;
(function (CameraMode) {
    /**
     * The normal Orbit mode where you can select cameras and orbit in their defined ranges.
     */
    CameraMode["Standard"] = "Standard";
    /**
     * There is only one camera where a focus point can be dynamically set.
     * It supports Panning and so you can freely navigate around and in the Car.
     */
    CameraMode["FreeOrbit"] = "FreeOrbit";
})(CameraMode || (CameraMode = {}));
//# sourceMappingURL=camera-mode.js.map